var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex"}},[_c('div',{staticStyle:{"width":"200px","height":"300px","background-color":"red"}}),_c('div',{staticClass:"scale-box",style:({
	    transform: ("scale(" + _vm.scale + ") translate(-50%, -50%)"),
	    WebkitTransform: ("scale(" + _vm.scale + ") translate(-50%, -50%)"),
	    width: _vm.width + 'px',
	    height: _vm.height + 'px',
	  })},[_c('H1',{staticClass:"mt-60px"},[_vm._v("测试")])],1),_c('div',{staticStyle:{"width":"200px","height":"300px","background-color":"yellow"}})])}
var staticRenderFns = []

export { render, staticRenderFns }